import type { components } from '@/api/types';

/** One approval-basis breakdown box from the portal summary: the approved
 *  recovery the practitioner tagged with a given `approval_reason`. Sourced
 *  straight from the generated API type so it can't drift. */
export type ApprovalReasonRecovery = components['schemas']['ApprovalReasonRecoveryOut'];

export interface ApprovalSubtypeBox {
  reason: string;
  label: string;
  amountCad: number;
  findingCount: number;
  /** Only an invoice reviewed for this transaction is the strongest evidence
   *  tier; the box for it gets the emphasized (emerald) treatment. */
  isStrongest: boolean;
}

/** Map the API's per-reason list to render-ready boxes, preserving the
 *  server's canonical strongest-first order. Kept pure + tested so the
 *  card just renders. INP-714. */
export function approvalSubtypeBoxes(
  entries: ApprovalReasonRecovery[],
): ApprovalSubtypeBox[] {
  return entries.map((entry) => ({
    reason: entry.reason,
    label: entry.label,
    amountCad: Number(entry.amount_cad),
    findingCount: entry.finding_count,
    isStrongest: entry.reason === 'invoice_confirmed',
  }));
}
